export const color = {
   red: '#dc3545',
}
 